'use strict';

function isObjectType(obj, type) {
  return !!obj && (type || typeof obj) === 'object';
}

module.exports = isObjectType;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/isObjectType.js
// module id = 65
// module chunks = 0